import { ResourceList } from 'models/Navigation'
import { useTranslation } from 'react-i18next'
import { NavLinkList } from '../NavLinkList/NavLinkList'
import { ArrowIcon } from '@cmsgov/ds-medicare-gov'

interface SubNavProps {
  analyticsCategory: string;
  menu?: React.ReactNode;
  menuName: string;
  sections?: ResourceList[];
  onBack: () => void;
}

export const SubNav: React.FC<SubNavProps> = ({ analyticsCategory, menuName, sections, onBack, menu }) => {
  const { t } = useTranslation('common')

  return (
    <>
      <button
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        className='nav-menu-button ch-u-width--full ch-u-hover-text-decoration--underline'
        onClick={onBack}
        type='button'
      >
        <span className='ds-u-display--flex ds-u-align-items--center'>
          <ArrowIcon direction='left' className='ds-u-margin-right--1' />
          <span className='ch-u-font--rubik'>{t('back')}</span>
        </span>
      </button>

      <hr className='ds-u-margin-y--0 ds-u-margin-x--3 ds-u-border--0 ds-u-fill--gray-lighter' style={{ height: '1px' }} />

      {
        sections
          ? sections.map((section: ResourceList) => (
            <NavLinkList analyticsCategory={analyticsCategory} key={section.id} menuName={menuName} {...section} />
          ))
          : menu
      }
    </>
  )
}
